// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import DropdownFooter from '../internal/components/dropdown-footer';
import { KeyCode } from '../internal/keycode';
import testUtilStyles from './test-classes/styles.css.js';
// Wraps the shared DropdownFooter so that interactions with the recovery button inside it are
// handled exclusively by the button and are not interpreted by the button dropdown handlers:
// a click must not toggle the enclosing expandable group, and Enter/Space must not activate the
// highlighted menu item or toggle the dropdown.
const StatusFooter = ({ content, id, hasItems, scope }) => {
    const stopActivationKeys = (event) => {
        if (event.keyCode === KeyCode.enter || event.keyCode === KeyCode.space) {
            event.stopPropagation();
        }
    };
    return (React.createElement("div", { className: testUtilStyles[`${scope}-status`], onClick: event => event.stopPropagation(), onKeyDown: stopActivationKeys, onKeyUp: stopActivationKeys },
        React.createElement(DropdownFooter, { content: content, id: id, hasItems: hasItems })));
};
export default StatusFooter;
//# sourceMappingURL=status-footer.js.map